import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Styles from './styles';

class ToggleSwitch extends React.Component {
  toggleSwitch = event => {
    event.stopPropagation();
    const { onToggle, id, toggled } = this.props;
    if (onToggle) onToggle(id, !toggled);
  };

  render() {
    const { onLabel, offLabel, toggled } = this.props;
    return (
      <Styles.ToggleSwitch className="ToggleSwitch" toggled={toggled} onClick={this.toggleSwitch}>
        <div className="handle">
          <span className="handle-label">
            {toggled
              ? onLabel || <FontAwesomeIcon icon="check" />
              : offLabel || <FontAwesomeIcon icon="times" />}
          </span>
        </div>
      </Styles.ToggleSwitch>
    );
  }
}

ToggleSwitch.propTypes = {
  id: PropTypes.string,
  toggled: PropTypes.bool,
  onLabel: PropTypes.string,
  offLabel: PropTypes.string,
  onToggle: PropTypes.func
};
// TODO remove id
ToggleSwitch.defaultProps = {
  id: '',
  toggled: false,
  onLabel: '',
  offLabel: '',
  onToggle: () => {}
};

export default ToggleSwitch;
